import axios from "axios";
import Gallery from 'vue-gallery';

import { Money } from "v-money";
import { mapState, mapActions } from "vuex";


import AppGravarVisitaDialog from "./dialogs/GravarVisitaDialog.vue";
import AppRetirarPlacaDialog from "./dialogs/RetirarPlacaDialog.vue";
import AppColocarPlacaDialog from "./dialogs/ColocarPlacaDialog.vue";
import AppUploadImagensDialog from "./dialogs/UploadImagensDialog.vue";
import AppFichaDoImovelDialog from "./dialogs/FichaDoImovelDialog.vue";
import AppReservarImovelDialog from "./dialogs/ReservarImovelDialog.vue";
import AppProrrogarReservaDialog from "./dialogs/ProrrogarReservaDialog.vue";
import AppDuplicarImovelDialog from "./dialogs/DuplicarImovelDialog.vue";

import AppUploadArquivoDialog from "../../shared/dialogs/UploadArquivoDialog.vue";
import AppGravarClienteDialog from "../../shared/dialogs/GravarClienteDialog.vue";
import AppCriarDiretorioDialog from "../../shared/dialogs/CriarDiretorioDialog.vue";
import AppCriarDiretorioArquivoDialog from "../../shared/dialogs/CriarDiretorioArquivoDialog.vue";
import AppSelecionarDiretorioArquivoDialog from "../../shared/dialogs/SelecionarDiretorioArquivosDialog.vue";  
import AppGravarObservacaoDialog from "../../shared/dialogs/GravarObservacaoDialog.vue";
import AppGravarCondominioDialog from "../../shared/dialogs/GravarCondominioDialog.vue";
import AppSelecionarDiretorioDialog from "../../shared/dialogs/SelecionarDiretorioDialog.vue";
import AppPerguntasFormularioDialog from "../../shared/dialogs/PerguntasFormularioDialog.vue";
import AppDisponibilizarAluguelDialog from "../../shared/dialogs/DisponibilizarAluguelDialog.vue";

import { AREA_PESQUISA_IMOVEL, ESTADOS, TIPOS_IMOVEIS, STATUS_VENDA, OPERACAO_IMOVEL, CATEGORIAS_VENDA, FILTROS_DASHBOARD, POSSE_CHAVE, AUTORIZACAO_PLACA, AUTORIZACAO_VENDA, DURACAO_RESERVA, PAISES, ZONAS } from "../../util/constantes.js";
import { validadorData } from "../../util/validadores";
import Util from "../../util/funcoes.js";
import URLS from "../../util/urls.js";

import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  components: {
    AppGravarVisitaDialog,
    AppRetirarPlacaDialog,
    AppColocarPlacaDialog,
    AppFichaDoImovelDialog,
    AppReservarImovelDialog,
    AppProrrogarReservaDialog,
    AppDuplicarImovelDialog,
    
    AppUploadArquivoDialog,
    AppUploadImagensDialog,
    AppGravarClienteDialog,
    AppCriarDiretorioDialog,
    AppCriarDiretorioArquivoDialog,
    AppSelecionarDiretorioArquivoDialog,
    AppGravarObservacaoDialog,
    AppGravarCondominioDialog,
    AppSelecionarDiretorioDialog,
    AppPerguntasFormularioDialog,
    AppDisponibilizarAluguelDialog,

    Gallery,
    Money,

    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      //PESQUISA
      quartosSuites: [
        { label: "01", data: "1" },
        { label: "02", data: "2" },
        { label: "03", data: "3" },
        { label: "04", data: "4" },
        { label: "05+", data: "5" }
      ],
      infiniteLoadingId: 0,
      infiniteLoadingIdRedeImob: 0,

      imagensViewerId: 0,
      imagemSelecionada: null,
      
      ordenacao: {
        ativa: false,
        indice: 0,
        ordemInicial: []
      },
      remocaoImagens: {
        ativa: false,
        imagens: []
      },
      
      filtroObservacoes: '',
      //CADASTRO
      validacao: {
        dataCaptacao: [
          { validator: validadorData, required: true }
        ],
        dataAutorizacao: [
          { validator: validadorData, required: false }
        ],
        tipoImovel: [ 
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        proprietario: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        endereco: [
          { type: "string", required: true }
        ],
        cep: [
          { type: "string", required: true, validator: this.validarCEPZipCode }
        ],
        estado: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        cidade: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        bairro: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        valor: [
          { type: "number", min: 0.01 }
        ],
        comissao: [
          { type: "number", min: 0, max: 100 }
        ],
        urlVideo: [{ validator: this.validarUrlVideo, required: false }],
      },

      zonaImovel: "",

      imovelSelecionado: undefined,

      tabKey: 0,
      tabSelecionada: "detalhes",
      tabSelecionadaParceria: 'parceria',
      loadingClientes: false,
      loadingCondominios: false,
      loadingCidades: false,
      loadingBairros: false,
      loadingCaptadores: false,
      loadingAtendente: false,
      loadingCaracteristicasImovel: false,
      loadingCaracteristicasCondominio: false,

      captadoresDisponiveis: [],
      captadorSelecionado: {},

      atendentesDisponiveis: [],
      atendenteSelecionado: {},

      comissaoCaptadorSelecionado: 0,

      caracteristicasSelecionadasImovel: [],
      caracteristicasImovelDisponivel: [],

      caracteristicasSelecionadasCondominio: [],
      caracteristicasCondominioDisponivel: [],

      exibirCaracteristicasImovel: false,
      exibirCaracteristicasCondominio: false,

      visibilidadeCriarDiretorioDialog: false,
      visibilidadeCriarDiretorioDialogArquivo: false,
      visibilidadeSelecionarDiretorioArquivoDialog: false,
      visibilidadeSelecionarDiretorioDialog: false,
      visibilidadeDuplicarImovelDialog: false,
      visibilidadeDialogFichaDoImovel: false,
      visibilidadeColocarPlacaDialog: false,
      visibilidadeGravarVisitaDialog: false,
      visibilidadeRetirarPlacaDialog: false,
      
      visibilidadeUploadArquivoDialog: false,
      visibilidadeUploadImagensDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeGravarCondominioDialog: false,
      visibilidadeGravarClienteDialog: false,
      visibilidadeReservarImovelDialog: false,
      visibilidadeProrrogarReservaDialog: false,
      visibilidadePerguntasFormularioDialog: false,
      visibilidadeDisponibilizarAluguelDialog: false,

      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      formularioSelecionado: { perguntasFormulario: [] },
      visitaSelecionada: undefined,
      placaRemocao: {},

      formulariosProps: {
        label: "nome",
        children: "formularios"
      },
      arquivoSelecionado: undefined,
      arquivosProps: {
        label: "nome",
        children: "arquivos"
      },
      keysArquivo: ["usuario","descricao","data","localizacaoFisica","extensao"],

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      squareMeter: {
        decimal: ",",
        thousands: ".",
        suffix: " m²",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },

      radioButtonImoveis: 'IMOVEIS_IMOBILIARIA',

      imagemSelecionadaParceria: null,

      hoverGravar: false,
      hoverRemover: false,
      hoverGerarFicha: false,
      hoverIndisponibilizar: false,
      hoverDuplicar: false,
      hoverDisponibilizarParaVenda: false,
      hoverDisponibilizar: false,
      hoverArquivar: false,
      
      urlMapa: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionMapa: '&copy; <a href="http:osm.org/copyright">OpenStreetMap</a> contributors',
      center: latLng(-5.0673272, -42.8014819),
      zoom: 14,
      icon: icon({
        iconUrl: require("../../dashboard/icons/mapIconRed.png"),
        iconSize: [32,37],
        iconAnchor: [16,37]
      })
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "IMOVEIS_VENDA" })[0] }
    }),
    ...mapState("vendasImoveisStore", {
      imoveis(state) { return state.imoveisListados },
      imovelPesquisa(state) { return state.imovelPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      exibirCamposPesquisa(state) { return state.exibirCamposPesquisa },

      imovel(state) { return state.imovelSelecionado },
      arquivos(state){ return state.imovelSelecionado.diretorios},
      ultimoIdCadastrado(state) { return state.ultimoIdCadastrado },
      logs(state) { return state.logs },

      clientesDisponiveis(state) { return state.clientesDisponiveis },
      formularios(state) { return state.formularios; },
      visitaAtiva(state) { return state.visitaAtiva },

      imovelParceiroPesquisa(state) { return state.imovelParceiroPesquisa },
      imoveisParceriaListados(state) { return state.imoveisParceriaListados },
      imovelParceiro(state) { return state.imovelParceiroSelecionado }
    }),

    condominiosDisponiveis: { 
      get() {
        return this.$store.state.vendasImoveisStore.condominiosDisponiveis
      },
      set(condominio) {
        this.$store.dispatch('vendasImoveisStore/atualizarCondominiosDisponiveis', condominio)
      }
    },

    cidadesDisponiveis: { 
      get() {
        return this.$store.state.vendasImoveisStore.cidadesDisponiveis
      },
      set(cidade) {
        this.$store.dispatch('vendasImoveisStore/atualizarCidadesDisponiveis', cidade)
      }
    },

    bairrosDisponiveis: { 
      get() {
        return this.$store.state.vendasImoveisStore.bairrosDisponiveis
      },
      set(bairro) {
        this.$store.dispatch('vendasImoveisStore/atualizarBairrosDisponiveis', bairro)
      }
    },

    centroMapa() { 
      if(this.imovel.latitude || this.imovel.longitude) {
        return latLng(this.imovel.latitude, this.imovel.longitude); 
      } else {
        return latLng(-5.0660888, -42.8042637);
      }
    },
    marcadorMapa() { 
      if(this.imovel.latitude || this.imovel.longitude) {
        return { lat: this.imovel.latitude, lng: this.imovel.longitude } 
      } else {
        return undefined;
      }
    },
    zoomMapa() {
      if(this.imovel.latitude || this.imovel.longitude) {
        return 17;
      } else {
        return 13;
      }
    },

    util() { return Util },
    area() { return AREA_PESQUISA_IMOVEL },
    paises() { return PAISES },
    zonas(){return ZONAS},
    estados() { return ESTADOS.filter(estado => { return estado.pais.id === this.imovel.pais.id }) },
    estadosImoveisParceiros() { return this.imovelParceiro.pais ? ESTADOS.filter(estado => { return estado.pais.id === this.imovelParceiro.pais.id }) : ESTADOS },
    tiposImoveis() { return TIPOS_IMOVEIS },
    categorias() { return CATEGORIAS_VENDA; },
    filtrosDashboard() { return FILTROS_DASHBOARD },
    status() { return STATUS_VENDA; },
    operacao() { return OPERACAO_IMOVEL; },
    posseChave() { return POSSE_CHAVE; },
    autorizacaoPlaca() { return AUTORIZACAO_PLACA; },
    autorizacaoVenda() { return AUTORIZACAO_VENDA; },

    imovelNovo() {
      return this.imovel.id == 0
    },
    disableAlteracao() {
      return this.imovel.id != 0
    },

    isDisponivel() {
      return this.imovel.status === 'DISPONIVEL';
    },
    isReservado() {
      return this.imovel.status === 'RESERVADO';
    },
    isVendido() {
      return this.imovel.status === 'VENDIDO';
    },

    isVisibleCamposSite() {
      return this.isDisponivel || this.isReservado;
    },
    
    campoProprietarioIsDisabled() {
      return this.isReservado || this.isVendido;
    },

    imovelTemQuarto() {
      return parseInt(this.imovel.quartos) > 0;
    },
    imovelTemSuite() {
      return parseInt(this.imovel.suites) > 0;
    },
    imovelTemSuiteReversivel() {
      return parseInt(this.imovel.suitesReversiveis) > 0;
    },
    imovelTemBanheiro() {
      return parseInt(this.imovel.banheiros) > 0;
    },
    imovelTemGaragemCoberta() {
      return parseInt(this.imovel.garagensCobertas) > 0;
    },
    imovelTemGaragemNaoCoberta() {
      return parseInt(this.imovel.garagensNaoCobertas) > 0;
    },

    disableAdicionarCaptador() {
      return !this.permissoes.alteracaoCorretor
    },
    observacoesFiltradas() {
      return this.imovel.observacoes
        .filter(this.filtrarObservacoes);
    },
    //CAMPOS
    exibirCampoCondominio() {
      return [1, 3, 5, 7, 9, 12, 18, 19].includes(this.imovel.tipoImovel.id);
    },
    visibilidadeCaracteristicasImovel(){
      return [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 13, 18, 19].includes(this.imovel.tipoImovel.id);
    },
    visibilidadeCaracteristicasCondominio(){
      return [1, 3, 5, 7, 9, 12, 14, 18, 19].includes(this.imovel.tipoImovel.id);
    },
    exibirCampoProprietario() {
      return this.imovel.categoria == "IMOVEL_AVULSO";
    },
    exibirCamposLancamento() {
      return this.imovel.categoria == "LANCAMENTO";
    },
    exibirCamposAgio() {
      return this.imovel.agio
    },
    exibirCampoAdicionarCaptador() {
      return (this.imovel.id == 0 && this.permissoes.cadastro) 
        || (this.imovel.id != 0 && this.permissoes.alteracaoCorretor)
    },
    
    //PESQUISA
    exibirBotaoNovo() {
      return this.permissoes.cadastro;
    },

    //DETALHES
    exibirBotaoGravar() { 
      return ((this.permissoes.cadastro && this.imovel.id == 0) || (this.permissoes.alteracao && this.imovel.id != 0))
      && this.radioButtonImoveis === 'IMOVEIS_IMOBILIARIA';
    },
    exibirBotaoRemover() {
      return this.permissoes.remocao
        && this.imovel.id != 0
        && ["INDISPONIVEL", "ARQUIVADO"].includes(this.imovel.status);
    },
    exibirBotaoGerarFicha() {
      return this.imovel.id != 0;
    },
    exibirBotaoDuplicar() { 
      return this.permissoes.cadastro
        && this.imovel.id != 0;
    },
    exibirBotaoDisponibilizar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && ["INDISPONIVEL"].includes(this.imovel.status);
    },
    exibirBotaoIndisponibilizar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && ["DISPONIVEL"].includes(this.imovel.status);
    },
    exibirBotaoArquivar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && ["INDISPONIVEL"].includes(this.imovel.status);
    },
    exibirBotaoDesarquivar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && ["ARQUIVADO"].includes(this.imovel.status);
    },
    exibirBotaoNovoCliente() {
      return this.imovel.id == 0;
    },
    exibirBotaoNovoCondominio() {
      return this.imovel.id == 0;
    },
    exibirBotaoGerarDescricaoImovel() {
      return this.imovel.tipoImovel.id !== 0;
    },
    exibirControleAcompanhamentoImovel(){
      return this.usuarioLogado.imobiliaria.emailAcompanhamentoImovel
        && this.usuarioLogado.imobiliaria.parametros.emailAcompanhamentoImovel
        && (this.isDisponivel || this.isReservado);
    },
    exibirBotaoDisponibilizarParaAluguel() {
      return this.usuarioLogado.imobiliaria.moduloAluguel &&
        this.permissoes.alteracao &&
        this.imovel.id !== 0 &&
        this.imovel.idImovelAssociado === 0 &&
        this.imovel.categoria === 'IMOVEL_AVULSO';
    },
    heightCaracteristicasImovel() {
      return this.exibirCaracteristicasImovel ? 'auto' : '200px';
    },
    heightCaracteristicasCondominio() {
      return this.exibirCaracteristicasCondominio ? 'auto' : '200px';
    },
    desabilitarAlteracaoIdImovel() {
      return !this.permissoes.alterarId && !this.imovelNovo;
    },

    //FORMULARIO
    exibirBotaoCriarDiretorio() {
      return this.permissoes.geracaoFormularios
        && this.tabSelecionada == "formularios";
    },
    exibirBotaoGerarFormulario() {
      return this.permissoes.geracaoFormularios 
        && this.tabSelecionada == "formularios"
        && this.formularioSelecionado.nomeArquivo;
    },

    exibirNomeProprietario() {
      if(this.usuarioLogado.imobiliaria.id == 68) {
        if(this.usuarioLogado.perfil == "ADMINISTRADOR" || this.usuarioLogado.perfil == "GERENTE") {
          return true;
        }
        return false;
      }
      return true;
    },

    exibirLinkParaProprietario() {
      return this.imovel.proprietariosBeneficiarios.length > 0;
    },

    //ARQUIVOS
    linhasArquivo(){
      if(this.arquivoSelecionado){
        return Object.entries(this.arquivoSelecionado)
        .filter(([key]) => this.keysArquivo.includes(key) )
        .map(([key,value]) => ({key, value})).sort((a, b ) => {
          if(a.key === "localizacaoFisica"){
            return 1
          }
          if(b.key === "localizacaoFisica"){
            return -1
          }
        })
      }      
    },
    //IMAGENS
    urlImagens() {
      return this.imovel.imagens.map(imagem => imagem.path);
    },
    urlImagensImovelParceiro() {
      return this.imovelParceiro.imagens.map(imagem => imagem.path);
    },
    exibirBotaoUploadImagem() {
      return !this.ordenacao.ativa && !this.remocaoImagens.ativa;
    },
    exibirBotaoRemoverImagens() {
      return !this.ordenacao.ativa && !this.remocaoImagens.ativa;
    },
    exibirBotaoOrdenar() {
      return !this.ordenacao.ativa && !this.remocaoImagens.ativa;
    },
    exibirBotaoConcluirOrdenacao() {
      return this.ordenacao.ativa;
    },
    exibirBotaoCancelarOrdenacao() {
      return this.ordenacao.ativa;
    },
    exibirBotaoCancelarRemocaoImagens() {
      return this.remocaoImagens.ativa;
    },
    exibirBotaoConcluirRemocaoImagens() {
      return this.remocaoImagens.ativa;
    },

    //VISITAS
    exibirBotoesVisita() {
      return this.tabSelecionada == "visitas"
        && this.imovel.id != 0
        && ["DISPONIVEL", "RESERVADO"].includes(this.imovel.status);
    },

    //PLACA
    exibirBotaoColocarPlaca() {
      return this.tabSelecionada == "placas"
        && this.imovel.autorizacaoPlaca == "PERMITIDO"
        && ["DISPONIVEL", "RESERVADO"].includes(this.imovel.status);
    },
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos";
    },

    //OBSERVACOES
    exibirBotaoRemoverObservacao() {
      return this.permissoes.removerObservacoes && this.imovel.id != 0 && this.tabSelecionada == "observacoes";
    },
    exibirBotaoGerarRelatorioObservacao() {
      return this.imovel.id != 0 && this.tabSelecionada == "observacoes";
    },

    //RESERVAS
    exibirContainerReserva() {
      return this.imovel.id != 0
        && this.imovel.reservas.length > 0
        && this.tabSelecionada == "resumo"
        && this.imovel.status == "RESERVADO"
    },
    exibirBotaoProrrogarReserva() {
      return this.permissoes.alterarReservas
        && this.imovel.id != 0
        && this.imovel.reservas.length > 0
        && this.tabSelecionada == "reservas"
        && this.imovel.status == "RESERVADO"
        && (this.usuarioLogado.id === this.imovel.reservas[0].usuario.id || this.usuarioLogado.id === this.imovel.reservas[0].usuarioReserva.id)
        && (this.imovel.alugueisAnteriores.length === 0 || this.imovel.alugueisAnteriores[0].status !== 'PENDENTE');
    },
    exibirBotaoDesfazerReserva() {
      return this.permissoes.alterarReservas
        && this.imovel.id != 0
        && this.imovel.reservas.length > 0
        && this.tabSelecionada == "reservas"
        && this.imovel.status == "RESERVADO"
        && (this.usuarioLogado.id === this.imovel.reservas[0].usuario.id || this.usuarioLogado.id === this.imovel.reservas[0].usuarioReserva.id)
        && (this.imovel.alugueisAnteriores.length === 0 || this.imovel.alugueisAnteriores[0].status !== 'PENDENTE');
    },
    exibirBotaoNovaReserva() {
      return this.permissoes.alterarReservas
        && this.imovel.id != 0
        && this.tabSelecionada == "reservas"
        && this.imovel.status == "DISPONIVEL";
    },

    //MAPA
    exibirBotaoGravarMapa() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "mapa";
    },

    labelCategoria() { return CATEGORIAS_VENDA.filter((value) => { return value.data == this.imovel.categoria })[0].label; },
    labelChave() { return CATEGORIAS_VENDA.filter((value) => { return value.data == this.imovel.categoria })[0].label; },

    visitasFiltradas() {
      if(this.atendenteSelecionado == undefined || this.atendenteSelecionado.id == undefined || this.atendenteSelecionado.id == 0) {
        return this.imovel.visitas;
      } else {
        return this.imovel.visitas.filter((visita) => { return visita.usuario.id == this.atendenteSelecionado.id });
      }
    },
    isVisitaAtiva() {
      return this.visitaAtiva.id !== 0;
    },
    isVisibleImoveisDaImobiliaria() {
      return this.radioButtonImoveis === 'IMOVEIS_IMOBILIARIA';
    },
    isVisibleImoveisParceiros() {
      return this.radioButtonImoveis === 'REDE_IMOB';
    },

    zipCepMaskChange() {
      if(this.imovel.pais.id === 1) {
        return '#####-###'
      } else {
        if(this.imovel.cep && this.imovel.cep.length > 5) {
          return '#####-####'
        } else {
          return '######'
        }
      }
    }
  },

  watch: {
    "imovel.id": function(newValue, oldValue) {
      if(newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.observacaoSelecionada = {};
      }
      this.condominiosDisponiveis = [this.imovel.condominio];
      this.cidadesDisponiveis = [this.imovel.cidade];
      this.bairrosDisponiveis = [this.imovel.bairro];
    },
    "imovel.estado.id": function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0 && this.imovelNovo) {
        this.imovel.cidade = { id: 0 };
        this.imovel.bairro = { id: 0 };
        
        this.cidadesDisponiveis = [];
        this.bairrosDisponiveis = [];
      }
    },
    "imovel.cidade.id": function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0 && this.imovelNovo) {
        this.imovel.bairro = { id: 0 };

        this.bairrosDisponiveis = [];
      }
    },
    "imovel.condominio.id": function(newValue, oldValue) {
      if(newValue != oldValue) {
        if(!newValue) return;

        this.atualizarEnderecoImovelParaCondominio(this.imovel.condominio)
      }
    }
  },

  async created() {
    await this.atualizarCaracteristicasImovel();
    await this.atualizarCaracteristicasCondominio();

    await this.recuperarUltimoId();

    this.configurarCampoCaptador();
  },

  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("vendasClientesStore", [
      "recuperarClienteVenda"
    ]),
    ...mapActions("vendasContratosStore", [
      "recuperarVenda"
    ]),
    ...mapActions("caracteristicasStore", [
      "listarCaracteristicasImovel",
      "listarCaracteristicasCondominio"
    ]),
    ...mapActions("usuariosStore", [
      "listarUsuarios"
    ]),
    ...mapActions("vendasImoveisStore", [
      "novoImovel",
      "limparImovelPesquisa",
      "limparImoveisListados",
      "listarImoveis",
      "recuperarImovel",
      "configurarCamposPesquisa",
      
      "gravarImovel",
      "disponibilizarImovel",
      "indisponibilizarImovel",
      "arquivarImovel",
      "desarquivarImovel",
      "removerImovel",

      "recuperarVisita",
      "removerVisitaImovel",

      "recuperarClientes",
      "recuperarCondominios",
      "recuperarCidades",
      "recuperarBairros",
      
      "recuperarUltimoIdCadastrado",
      "recuperarFormularios",
      "recuperarPerguntasFormulario",
      "gerarFormularioImovel",
      "removerDiretorioFormularios",
      "removerDiretorioArquivos",
      
      "recuperarLogsImovel",
      "recuperarObservacaoImovel",
      "removerObservacaoImovel",
      "gerarRelatorioObservacoesImovel",
      "removerArquivoImovel",
      "desfazerReserva",

      "reordenarImagensImovel",
      "exibirImagemNaFichaImovel",
      "removerImagensImovel",

      "gravarLocalizacaoImovel",
      "listarImoveisParceiros",
      "limparImoveisParceirosListas",
      "recuperarImovelParceiro",
      "limparImovelParceiroPesquisa",
      "limparDadosEndereco"
    ]),

    validarUrlVideo(rule, value, callback) {
      if(!value || !value.trim()) {
        return callback();
      }

      const pattern1regEx = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=.+$/;
      if(pattern1regEx.test(value)) {
        return callback();
      }

      const pattern2regEx = /^(https?:\/\/)?(www\.)?youtu\.be\/.+$/;
      if(pattern2regEx.test(value)) {
        return callback();
      }

      return callback(new Error());
    },

    validarCEPZipCode(rule, value, callback) {
      if(this.imovel.pais.id === 1) {
        if(value.length === 9) {
          return callback();
        }
      } else if(this.imovel.pais.id === 2) {
        if(value.length === 5 || value.length === 10) {
          return callback();
        }
      }

      return callback(new Error());
    },

    async atualizarCaracteristicasImovel() {
      this.showLoading();

      try {
        await this.recuperarCaracteristicasImovelSelect("");
      } catch(e) {
        this.$message.error("Não foi possível recuperar as características do imóvel");
      }

      this.hideLoading();
    },

    async atualizarCaracteristicasCondominio() {
      this.showLoading();

      try {
        await this.recuperarCaracteristicasCondominioSelect("");
      } catch(e) {
        this.$message.error("Não foi possível recuperar as características do condomínio");
      }

      this.hideLoading();
    },

    configurarCampoCaptador() {
      this.captadorSelecionado = this.usuarioLogado;

      const usuarioLogadoNotInCaptadoresDisponiveis = !this.captadoresDisponiveis.map(usuario => usuario.id)
        .includes(this.usuarioLogado.id);

      if(usuarioLogadoNotInCaptadoresDisponiveis) {
        this.captadoresDisponiveis.push(this.usuarioLogado);
      }
    },
    //PESQUISA
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    formatarValor(valor) {
      return "R$ " + Number(valor).toLocaleString("pt-BR");
    },

    novo() {
      this.$refs["form"].resetFields();
      this.tabKey++;
      this.novoImovel();
      
      this.condominiosDisponiveis = [];
      this.cidadesDisponiveis = [];
      this.bairrosDisponiveis = [];
      this.exibirCaracteristicasImovel = false;
      this.exibirCaracteristicasCondominio = false;
      this.caracteristicasSelecionadasImovel = new Array(this.caracteristicasImovelDisponivel.length);
      this.caracteristicasSelecionadasCondominio = new Array(this.caracteristicasCondominioDisponivel.length);
      this.configurarCampoCaptador();
    },
    pesquisarHandler() {
      this.imovelPesquisa.pagina = 0;
      this.limparImoveisListados();
      this.infiniteLoadingId += 1;
    },
    limparPesquisa() {
      this.limparImovelPesquisa();
    },
    pesquisar($state) {
      if(this.imovelPesquisa.pagina == 0) { this.showLoading(); }

      this.listarImoveis(this.imovelPesquisa)
      .then((resultado) => {
        if(this.imovelPesquisa.pagina == 0) { this.hideLoading(); }

        if(resultado.lista.length == 100) {
          this.imovelPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.imovelPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      });
    },

    pesquisarImoveisParceirosHandler() {
      this.imovelParceiroPesquisa.pagina = 0;
      this.limparImoveisParceirosListas();
      this.infiniteLoadingIdRedeImob += 1
    },

    pesquisarImoveisParceiros($state) {
      this.imovelParceiroPesquisa.imobiliaria = {
        id: this.usuarioLogado.imobiliaria.id,
        nome: this.usuarioLogado.imobiliaria.nome
      }
      if(this.imovelParceiroPesquisa.pagina == 0) { this.showLoading(); }

      this.listarImoveisParceiros(this.imovelParceiroPesquisa)
      .then((resultado) => {
        if(this.imovelParceiroPesquisa.pagina == 0) { this.hideLoading(); }

        if(resultado.lista.length == 100) {
          this.imovelParceiroPesquisa += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.imovelParceiroPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      });
    },

    //RESUMO
    recuperarProprietario() {
      let payload = { id: this.imovel.proprietario.id };

      this.showLoading();
      this.recuperarClienteVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/clientes");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
    },

    //CADASTRO
    getLabel(array, element) {
      return Util.getLabel(array, element);
    },

    tabClicked(tab) {
      if(tab.name === "logs") {
        this.recuperarLogs();
      }

      if(tab.name === 'formularios') {
        this.handleRecuperarFormularios();
      }

      if(tab.name === 'mapa') {
        setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 50);
      }
    },

    handleRecuperarFormularios() {
      const payload = { tipo: "IMOVEL_VENDA" };
      this.showLoading();

      this.recuperarFormularios(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    
    // CAPTADORES
    recuperarCaptadoresSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingCaptadores = true;
      this.listarUsuarios(payload)
      .then((resultado) => {
        this.loadingCaptadores = false;
        switch(resultado.status) {
          case "SUCESSO":
            this.captadoresDisponiveis = resultado.lista;
            break;
        }
      }).catch(() => {
        this.loadingCaptadores = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    adicionarCaptador() {
      if(this.captadorSelecionado == undefined || this.captadorSelecionado.id == undefined || this.captadorSelecionado.id == 0) { return; }
      if(this.comissaoCaptadorSelecionado == undefined || this.comissaoCaptadorSelecionado <= 0) { return; }

      if(this.imovel.captadores.filter((elemento) => { return elemento.id == this.captadorSelecionado.id }).length == 0) {
        this.captadorSelecionado.comissao = this.comissaoCaptadorSelecionado;
        this.imovel.captadores.push(this.captadorSelecionado);
      }

      this.captadoresDisponiveis = [];
      this.captadorSelecionado = {};
      this.comissaoCaptadorSelecionado = 0;
    },
    removerCaptador(captador) {
      this.imovel.captadores = this.imovel.captadores.filter((elemento) => { return elemento.id != captador.id });
    },

    //CARACTERISTICAS IMOVEL
    async recuperarCaracteristicasImovelSelect(queryString) {
      const payload = {
        nome: queryString,
      };

      this.loadingCaracteristicasImovel = true;

      const resultado = await this.listarCaracteristicasImovel(payload);
      this.caracteristicasImovelDisponivel = (resultado.status == "SUCESSO" ? resultado.lista : []);

      this.loadingCaracteristicasImovel = false;
    },
    configurarCaracteristicasImovel(){
      this.exibirCaracteristicasImovel = !this.exibirCaracteristicasImovel;
    },

    //CARACTERISTICAS CONDOMINIO
    async recuperarCaracteristicasCondominioSelect(queryString) {
      const payload = {
        nome: queryString,
      };

      this.loadingCaracteristicasCondominio = true;

      const resultado = await this.listarCaracteristicasCondominio(payload);
      this.caracteristicasCondominioDisponivel = (resultado.status === "SUCESSO" ? resultado.lista : []);

      this.loadingCaracteristicasCondominio = false;
    },
    
    configurarCaracteristicasCondominio(){
      this.exibirCaracteristicasCondominio = !this.exibirCaracteristicasCondominio;
    },

    //IMOVEL
    recuperar(imovel) {
      this.irParaSecao();
      const payload = { id: imovel.id };
      this.showLoading();
      this.recuperarImovel(payload)
      .then(resultado => {
        switch(resultado.status) {
          case "SUCESSO":
            this.preencherCaracteristicas(resultado.item);
            this.configurarCampoCaptador();
            this.hideLoading();
            break;
          case "FALHA":
          case "ERRO":
            this.hideLoading();
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },

    async recuperarUltimoId() {
      this.showLoading();

      try {
        await this.recuperarUltimoIdCadastrado();
      } catch(e) {
        this.$message.error("Não foi possível recuperar o último ID");
      }

      this.hideLoading();
    },

    preencherCaracteristicas(imovel) {
      let caracteristicasSelecionadas;
      let filtro;

      this.caracteristicasSelecionadasImovel = [];
      this.caracteristicasSelecionadasCondominio = [];
      caracteristicasSelecionadas = imovel.caracteristicasImovel;

      this.caracteristicasImovelDisponivel.forEach(caracteristicaDisponivel => {
        filtro = caracteristicasSelecionadas.filter((caracteristicaSelecionada) => { return caracteristicaSelecionada.id == caracteristicaDisponivel.id });
        if(filtro.length > 0) {
          this.caracteristicasSelecionadasImovel.push(filtro[0].id);
        } else {
          this.caracteristicasSelecionadasImovel.push(0);
        }
      });

      caracteristicasSelecionadas = imovel.caracteristicasCondominio;

      this.caracteristicasCondominioDisponivel.forEach(caracteristicaDisponivel => {
        filtro = caracteristicasSelecionadas.filter((caracteristicaSelecionada) => { return caracteristicaSelecionada.id == caracteristicaDisponivel.id });
        if(filtro.length > 0) {
          this.caracteristicasSelecionadasCondominio.push(filtro[0].id);
        } else {
          this.caracteristicasSelecionadasCondominio.push(0);
        }
      });
    },

    gravarHandler() {
      if(this.imovel.categoria === 'IMOVEL_AVULSO') { 
        this.validacao.proprietario = [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ]
      } else {
        delete this.validacao.proprietario
      }

      this.$refs["form"].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.imovel.caracteristicasImovel = this.caracteristicasSelecionadasImovel.filter((elemento) => { return elemento != 0}).map((elemento) => { return { id: elemento } });
      this.imovel.caracteristicasCondominio = this.caracteristicasSelecionadasCondominio.filter((elemento) => { return elemento != 0}).map((elemento) => { return { id: elemento } });
      if(this.imovel.categoria == 'LANCAMENTO') {
        this.imovel.proprietariosBeneficiarios = []
      }

      this.showLoading();
      this.gravarImovel(this.imovel)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.recuperarUltimoId();
            this.pesquisarHandler();
            this.configurarCampoCaptador();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    limpar() {
      this.$refs["form"].resetFields();
    },
    removerHandler() {
      this.$confirm("Deseja realmente remover este imóvel?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.remover();
      }).catch(() => {});
    },
    remover() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.removerImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      })
    },

    disponibilizar() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.disponibilizarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    indisponibilizar() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.indisponibilizarImovel(payload).then(resultado => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    arquivar() {
      let payload = { id: this.imovel.id };
      
      this.showLoading();
      this.arquivarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    desarquivar() {
      let payload = { id: this.imovel.id };
      
      this.showLoading();
      this.desarquivarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    gerarDescricaoImovel() {
      let descricao = '';

      descricao += this.imovel.tipoImovel.nome + ', ';

      if(this.imovelTemQuarto) {
        descricao += Util.formatar2Digitos(parseInt(this.imovel.quartos));
        descricao += parseInt(this.imovel.quartos) === 1 ? ' quarto, ' : ' quartos, ';
      }

      if(this.imovelTemSuite) {
        descricao += this.imovelTemQuarto ? 'sendo ' : '';
        descricao += Util.formatar2Digitos(parseInt(this.imovel.suites));
        descricao += parseInt(this.imovel.suites) === 1 ? ' suíte, ' : ' suítes, ';
      }

      if(this.imovelTemSuiteReversivel) {
        if(this.imovelTemQuarto) {
          if(this.imovelTemSuite) {
            descricao += 'e ';
          }
          else {
            descricao += 'sendo ';
          }
        }

        descricao += Util.formatar2Digitos(parseInt(this.imovel.suitesReversiveis));
        descricao += parseInt(this.imovel.suitesReversiveis) === 1 ? ' suíte reversível, ' : ' suítes reversíveis, ';
      }

      if(this.imovelTemBanheiro) {
        descricao += Util.formatar2Digitos(parseInt(this.imovel.banheiros));
        descricao += parseInt(this.imovel.banheiros) === 1 ? ' banheiro, ' : ' banheiros, ';
      }

      if(this.imovelTemGaragemCoberta) {
        descricao += Util.formatar2Digitos(parseInt(this.imovel.garagensCobertas));
        descricao += parseInt(this.imovel.garagensCobertas) === 1 ? ' garagem coberta, ' : ' garagens cobertas, ';
      }

      if(this.imovelTemGaragemNaoCoberta) {
        descricao += Util.formatar2Digitos(parseInt(this.imovel.garagensNaoCobertas));
        descricao += parseInt(this.imovel.garagensNaoCobertas) === 1 ? ' garagem não coberta, ' : ' garagens não cobertas, ';
      }

      const idsCaracteristicasImovelSelecionadas = this.caracteristicasSelecionadasImovel
        .filter(elemento => elemento != 0);

      const caracteristicasImovelSelecionadas = this.caracteristicasImovelDisponivel
        .filter(item => idsCaracteristicasImovelSelecionadas.includes(item.id))
        .map(item => item.nome);

      for(const[i, caracteristica] of caracteristicasImovelSelecionadas.entries()) {
        if(i === caracteristicasImovelSelecionadas.length - 1) {
          descricao += caracteristica;
        } else {
          descricao += caracteristica + ', ';
        }
      }

      const idsCaracteristicasCondominioSelecionadas = this.caracteristicasSelecionadasCondominio
        .filter(elemento => elemento != 0);

      if(idsCaracteristicasCondominioSelecionadas.length > 0) {
        descricao += '. Características do condomínio: ';
      }

      const caracteristicasCondominioSelecionadas = this.caracteristicasCondominioDisponivel
        .filter(item => idsCaracteristicasCondominioSelecionadas.includes(item.id))
        .map(item => item.nome);

      for(const[i, caracteristica] of caracteristicasCondominioSelecionadas.entries()) {
        if(i === caracteristicasCondominioSelecionadas.length -1) {
          descricao += caracteristica;
        } else {
          descricao += caracteristica + ', ';
        }
      }

      if(this.usuarioLogado.imobiliaria.parametros.letrasMaiusculas) {
        descricao = descricao.toUpperCase();
      }

      this.imovel.descricao = descricao + ' ' + this.imovel.descricao;
      this.imovel.descricaoSite = descricao + ' ' + this.imovel.descricaoSite;
    },

    exibirDuplicarImovelDialog() {
      this.visibilidadeDuplicarImovelDialog = true;
    },
    fecharDialogDuplicarImovel() {
      this.visibilidadeDuplicarImovelDialog = false;
      this.preencherCaracteristicas(this.imovel);
      this.$message.success('Imóvel duplicado com sucesso');
    },

    //IMAGENS
    exibirDialogUploadImagens() {
      this.visibilidadeUploadImagensDialog = true;
    },
    fecharDialogUploadImagens() {
      this.visibilidadeUploadImagensDialog = false;
    },
    imagemClickHandler(indice) {
      if(this.ordenacao.ativa) { this.alterarOrdemImagens(indice); }
      else if(this.remocaoImagens.ativa) { this.adicionarImagemParaRemocao(indice); }
      else { this.imagemSelecionada = indice; }
    },
    alterarOrdemImagens(indice) {
      if(indice < this.ordenacao.indice) {
        return;
      }

      let imagem1 = this.imovel.imagens[this.ordenacao.indice];
      imagem1.ordem = indice;
      
      let imagem2 = this.imovel.imagens[indice];
      imagem2.ordem = this.ordenacao.indice;

      this.imovel.imagens[this.ordenacao.indice] = imagem2;
      this.imovel.imagens[indice] = imagem1;

      this.ordenacao.indice++;
      this.imagensViewerId++;
    },
    adicionarImagemParaRemocao(indice) {
      if(this.remocaoImagens.imagens.includes(this.imovel.imagens[indice])) {
        this.remocaoImagens.imagens = this.remocaoImagens.imagens.filter((imagem) => { return imagem.id != this.imovel.imagens[indice].id });
      } else {
        this.remocaoImagens.imagens.push(this.imovel.imagens[indice]);
      }
    },
    iniciarOrdenacaoHandler() {
      this.ordenacao.ativa = true;
      this.ordenacao.indice = 0;
      this.ordenacao.ordemInicial = this.imovel.imagens.slice();
    },
    concluirOrdenacaoHandler() {
      let payload = {
        id: this.imovel.id,
        imagens: this.imovel.imagens
      }

      this.reordenarImagens(payload);
    },
    cancelarOrdenacaoHandler() {
      this.ordenacao.ativa = false;
      this.ordenacao.indice = 0;
      this.imovel.imagens = this.ordenacao.ordemInicial.slice();
      this.ordenacao.ordemInicial = [];
    },
    reordenarImagens(payload) {
      this.showLoading();
      this.reordenarImagensImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);

            this.ordenacao.ativa = false;
            this.ordenacao.indice = 0;
            this.ordenacao.ordemInicial = [];
            break;
          case "FALHA":
          case "ERRO":
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    exibirImagemNaFichaHandler(indice) {
      let payload = {
        id: this.imovel.imagens[indice].id,
        exibirNaFicha: this.imovel.imagens[indice].exibirNaFicha
      }
      this.exibirImagemNaFicha(payload);
    },
    exibirImagemNaFicha(payload) {
      this.showLoading()
      this.exibirImagemNaFichaImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success("Alteração realizada com sucesso");
            break;
          case "FALHA":
          case "ERRO":
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    iniciarRemocaoImagensHandler() {
      this.remocaoImagens.ativa = true;
      this.remocaoImagens.imagens = [];
    },
    concluirRemocaoImagensHandler() {
      if(this.remocaoImagens.imagens.length == 0) { this.cancelarRemocaoImagensHandler(); return; }

      this.$confirm("Deseja realmente remover as imagens selecioandas?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerImagens();
      }).catch(() => {
        this.cancelarRemocaoImagensHandler();
      });
    },
    removerImagens() {
      let payload = {
        id: this.imovel.id,
        imagens: this.remocaoImagens.imagens
      }

      this.showLoading();
      this.removerImagensImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        this.cancelarRemocaoImagensHandler();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.cancelarRemocaoImagensHandler();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    cancelarRemocaoImagensHandler() {
      this.remocaoImagens.ativa = false;
      this.remocaoImagens.imagens = [];
    },

    imagemParceriaClickHandler(indice) {
      this.imagemSelecionadaParceria = indice;
    },

    //SELECTS
    recuperarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString
      
      this.loadingClientes = true;
      this.recuperarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      });
    },
    recuperarCondominiosSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingCondominios = true;
      this.recuperarCondominios(payload)
      .then(() => {
        this.loadingCondominios = false;
      });
    },
    recuperarCidadesSelect(queryString) {
      if(this.imovel.estado.id == 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.imovel.estado.id } };
      
      this.loadingCidades = true;
      this.recuperarCidades(payload)
      .then(() => {
        this.loadingCidades = false;
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.imovel.cidade.id == 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.imovel.cidade.id } };

      this.loadingBairros = true;
      this.recuperarBairros(payload)
      .then(() => {
        this.loadingBairros = false;
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },      

    //PLACAS
    exibirDialogColocarPlaca() {
      this.visibilidadeColocarPlacaDialog = true;
    },
    fecharDialogColocarPlaca() {
      this.visibilidadeColocarPlacaDialog = false;
    },
    exibirDialogRetirarPlaca(placa) {
      this.placaRemocao = Object.assign({}, placa);
      this.placaRemocao.status = "RETIRADA";
      this.placaRemocao.dataRemocao = Util.hoje();
      this.placaRemocao.imovel = { id: this.imovel.id };

      this.visibilidadeRetirarPlacaDialog = true;
    },
    fecharDialogRetirarPlaca() {
      this.visibilidadeRetirarPlacaDialog = false;
    },
    exibirDialogFichaDoImovel() {
      this.visibilidadeDialogFichaDoImovel = true
    },
    fecharDialogFichaDoImovel() {
      this.visibilidadeDialogFichaDoImovel = false;
    },

    //FORMULARIOS - DIRETORIOS
    exibirDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = true;
    },
    fecharDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = false;
    },
    exibirDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = true;
    },
    fecharDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = false;
    },
    exibirDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = true;
    },
    fecharDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = false;
    },
    exibirBotaoRemoverDiretorioArquivo(data) {
      return data.nome !== "Outros";
    },
    exibirBotaoRemoverDiretorioFormulario(data) {
      return data.nomeArquivo === undefined && data.nome !== "Outros";
    },
    removerDiretorioHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorio(diretorio);
      });
    },
    removerDiretorio(diretorio) {
      let payload = { id: diretorio.id, tipoFormularios: diretorio.tipoFormularios, idObjeto: this.imovel.id};

      this.showLoading();
      this.removerDiretorioFormularios(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },

    //FORMULARIOS - GERAÇÃO
    selecionarFormulario(formularioSelecionado) {
      if(formularioSelecionado.nomeArquivo !== undefined && formularioSelecionado.nomeArquivo !== null) {
        this.formularioSelecionado = formularioSelecionado;
      } else {
        this.formularioSelecionado = { perguntasFormulario: [] };
      }
    },
    selecionarArquivo(arquivoSelecionado) {
      if(arquivoSelecionado !== undefined && arquivoSelecionado.descricao !== null) {
        this.arquivoSelecionado = arquivoSelecionado;
      }
    },
    gerarFormulario(formularioSelecionado) {
      if(!formularioSelecionado || !formularioSelecionado.id) { return; }

      let payload = { id: formularioSelecionado.id };

      this.showLoading();
      this.recuperarPerguntasFormulario(payload)
      .then(resultado => {
        switch(resultado.status) {
        case "SUCESSO":
          this.finalizarGeracaoFormulario(resultado);
          break;
        }
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.hideLoading();
      });
    },
    finalizarGeracaoFormulario(resultado) {
      this.formularioSelecionado = resultado.item;
      this.formularioSelecionado.imovel = this.imovel;

      if(this.formularioSelecionado.perguntasFormulario) {
        this.exibirDialogPerguntasFormulario();
        this.hideLoading();
      } else {
        this.gerarFormularioImovel(this.formularioSelecionado)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
          }
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },
    exibirDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = true;
    },
    fecharDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = false;
    },

    exibirDialogDisponibilizarAluguel() {
      this.visibilidadeDisponibilizarAluguelDialog = true;
    },
    fecharDialogDisponibilizarAluguel() {
      this.visibilidadeDisponibilizarAluguelDialog = false;
    },

    formatarLabelFormulario(formulario) {
      if(formulario.nomeArquivo != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTree(formulario) {
      if(formulario.nomeArquivo != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },

    //ARQUIVOS
    labelPropriedades(key){
      switch (key) {
        case "usuario":
          return "Usuário";
        case "data":
          return "Envio";
        case "localizacaoFisica":
          return "Observações";    
        case "descricao":
          return "Nome";
        case "extensao":
          return "Extensão do arquivo";  
        default:
          break;
      }
    },
    removerArquivosHandler(data){
      if(data.descricao){
        this.removerArquivoHandler(data)
      }else{
        this.removerDiretorioArquivosHandler(data)
      }
    },
    removerDiretorioArquivosHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorioArquivo(diretorio);
      });
    },
    removerDiretorioArquivo(diretorio) {
      let payload = { id: diretorio.id, idImovel: this.imovel.id};

      this.showLoading();
      this.removerDiretorioArquivos(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    formatarLabelArquivo(arquivo) {
      if(arquivo.descricao != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTreeArquivo(arquivo) {
      if(arquivo.descricao != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    exibirDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = true;
    },
    fecharDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = false;
    },
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    removerArquivoHandler(arquivo) {
      this.$confirm("Deseja realmente remover este arquivo?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerArquivo(arquivo);
      }).catch(() => {});
    },
    removerArquivo(arquivo) {
      let payload = { id: arquivo.id };
      
      this.showLoading();
      this.removerArquivoImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },

    //VISITAS
    coresStatusVisitas(status) {
      switch(status) {
        case "Nova":
          return "#67C23A";
        case "Finalizada":
          return  "#008080";
        case "Em andamento":
          return "#E6A23C";
      }
    },
    labelStatusVisita(row){
      return row.chavePosseCliente == false && row.mensagemChave == null ? 'Nova' : (row.id == this.visitaAtiva.id ? 'Em andamento' : 'Finalizada')
    },
    exibirDialogGravarVisita() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = true;
    },
    fecharDialogGravarVisita() { 
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = false;
    },
    alterarVisita(visita, column) {
      if(column.columnKey == "acoes") { return }

      let payload = { id: visita.id, imoveis: [{ id: this.imovel.id }] }

      this.showLoading();
      this.recuperarVisita(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.visitaSelecionada = resultado.item;
            this.visibilidadeGravarVisitaDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    removerVisitaHandler(visita) {
      this.$confirm("Deseja realmente remover esta visita?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerVisita(visita);
      }).catch(() => {});
    },
    removerVisita(visita) {
      let payload = { 
        id: visita.id,
        imoveis: [{ id: this.imovel.id }]
      };
      
      this.showLoading();
      this.removerVisitaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    recuperarAtendentesSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingAtendente = true;
      this.listarUsuarios(payload)
      .then((resultado) => {
        this.loadingAtendente = false;
        if(resultado.status == "SUCESSO") {
          this.atendentesDisponiveis = resultado.lista;
        }
      }).catch(() => {
        this.loadingAtendente = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    gerarRelatorioVisitas() {
      let payload = { 
        nome: "VISITAS_IMOVEIS",
        imovel: { id: this.imovel.id },
        usuario: { id: this.atendenteSelecionado.id }
      };

      this.showLoading();
      axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        this.hideLoading();
        switch(response.data.status) {
          case "SUCESSO": 
            window.open(response.data.mensagem, "_blank");
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    //OBSERVACOES
    exibirDialogGravarObservacao() {
      this.observacaoEmEdicao = undefined;
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharDialogGravarObservacao() {
      this.observacaoEmEdicao = undefined;
      this.visibilidadeGravarObservacaoDialog = false;
    },
    exibirObservacao(observacao) {
      this.observacaoSelecionada = observacao;
    },
    alterarObservacao(observacao, column) {
      if(column.columnKey == "acoes") { return }
      if(!this.permissoes.alterarObservacoes) { return }
      if(this.permissoes.alterarObservacoesSomenteCorretor && observacao.usuario.id !== this.usuarioLogado.id) { return }

      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.observacaoEmEdicao = resultado.item;
            this.observacaoSelecionada = {};
            this.visibilidadeGravarObservacaoDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    removerObservacaoHandler(observacao) {
      this.$confirm("Deseja realmente remover esta observação?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerObservacao(observacao);
      }).catch(() => {});
    },
    removerObservacao(observacao) {
      let payload = { id: observacao.id }
      
      this.showLoading();
      this.removerObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.observacaoSelecionada = {}
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    gerarRelatorioObservacao() {
      let payload = { 
        nome: "OBSERVACOES_IMOVEL",
        imovel: { id: this.imovel.id }
      };

      this.showLoading();
      this.gerarRelatorioObservacoesImovel(payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            window.open(response.mensagem, "_blank");  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    //RESERVAS
    exibirDialogReservarImovel() {
      this.visibilidadeReservarImovelDialog = true;
    },
    fecharDialogReservarImovel() {
      this.visibilidadeReservarImovelDialog = false;
    },
    reservarImovel() {
      this.visibilidadeReservarImovelDialog = false;
      this.pesquisarHandler();
    },
    exibirDialogProrrogarReserva() {
      this.visibilidadeProrrogarReservaDialog = true;
    },
    fecharDialogProrrogarReserva() {
      this.visibilidadeProrrogarReservaDialog = false;
    },
    prorrogarReserva() {
      this.visibilidadeProrrogarReservaDialog = false;
      this.pesquisarHandler();
    },
    desfazerReservaHandler() {
      let payload = { id: this.imovel.id }
      this.showLoading();

      this.desfazerReserva(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.pesquisarHandler()
            this.$message.success(resultado.mensagem)
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem)
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem)
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },

    formatarDuracaoReserva(reserva) {
      return this.getLabel(DURACAO_RESERVA, reserva.duracao);
    },

    //MAPA
    mapRclicked(mouseArgs) {
      this.imovel.latitude = mouseArgs.latlng.lat;
      this.imovel.longitude = mouseArgs.latlng.lng;
    },
    gravarMapaHandler() {
      let payload = { 
        id: this.imovel.id,
        latitude: this.imovel.latitude,
        longitude: this.imovel.longitude
      }
      
      this.showLoading();
      this.gravarLocalizacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        if(resultado.status == "SUCESSO") {
          this.$message.success(resultado.mensagem);
        } else {
          this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    //LOGS
    recuperarLogs() {
      const payload = { imovel: { id: this.imovel.id }, pagina: -1 };
      this.showLoading();

      this.recuperarLogsImovel(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível recuperar os logs deste imóvel");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    //POPUP CONDOMINIO
    exibirDialogGravarCondominio() {
      this.visibilidadeGravarCondominioDialog = true;
    },
    fecharDialogGravarCondominio(condominio) {
      if(condominio) {
        this.imovel.condominio = condominio;
        this.condominiosDisponiveis = [condominio];

        this.atualizarEnderecoImovelParaCondominio();
      }
      this.visibilidadeGravarCondominioDialog = false;
    },
    atualizarEnderecoImovelParaCondominio() {
      this.imovel.endereco = this.imovel.condominio.endereco;
      this.imovel.numeroEndereco = this.imovel.condominio.numeroEndereco;
      this.imovel.pontoDeReferencia = this.imovel.condominio.pontoDeReferencia;
      this.imovel.cep = this.imovel.condominio.cep;
      this.imovel.estado = this.imovel.condominio.estado;
      this.imovel.cidade = this.imovel.condominio.cidade;
      this.imovel.bairro = this.imovel.condominio.bairro;

      this.cidadesDisponiveis = [this.imovel.cidade];
      this.bairrosDisponiveis = [this.imovel.bairro];
    },

    //POPUP CLIENTE
    exibirDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = true;
    },
    fecharDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = false;
      this.incluirPerfilProprietario(this.imovel.proprietario);
    },

    //HELPER FUNCTIONS
    incluirPerfilProprietario(cliente) {
      cliente.perfis = [{ 
        perfil: 'PROPRIETARIO',
        participacaoRecebimento: 100
      }];
      this.imovel.proprietariosBeneficiarios = [cliente];
    },
    coresPesquisa(status) {
      switch(status) {
        case "RESERVADO":
          return "#FF9E29";
        case "DISPONIVEL":
          return "#2DB748";
        case "INDISPONIVEL":
          return "#DF1B1B";
        case "ARQUIVADO":
          return "#A1A4A8";
        case "VENDIDO":
          return "#4B6EF6";
      }
    },
    corBordaOrdenacao(indice) {
      if(this.ordenacao.ativa) {
        if(indice < this.ordenacao.indice) {
          return "#A1A1A1";
        } else if(indice == this.ordenacao.indice) {
          return "#67C23A";
        } else {
          return "#FFFFFF";
        }
      } else if(this.remocaoImagens.ativa) {
        if(this.remocaoImagens.imagens.includes(this.imovel.imagens[indice])) {
          return "#F56C6C";
        } else {
          return "#FFFFFF";
        }
      } else {
        return "#FFFFFF";
      }
    },

    formatarStatusDoImovel(status) {
      return Util.getLabel(STATUS_VENDA, status);
    },

    filtrarObservacoes(observacao) {
      const descricao = observacao.descricao !== null ? Util.removerAcentos(observacao.descricao.trim().toLowerCase()) : '';
      const assunto = observacao.assunto !== null ? Util.removerAcentos(observacao.assunto.trim().toLowerCase()) : '';
      
      const searchTerm = Util.removerAcentos(this.filtroObservacoes.trim().toLowerCase());

      return descricao.includes(searchTerm) || assunto.includes(searchTerm);
    },

    recuperarContratoVenda(venda) {
      let payload = { id: venda.id }
      this.showLoading();
      this.recuperarVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/vendas");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message("Não foi possível se comunicar com o servidor.");
          this.hideLoading();
        })
    },

    siglaEstado(imovel){
      return ESTADOS.filter(item => {return item.id === imovel.estado.id})[0].sigla
    },
    formatarLinha2EnderecoImovel(imovel) {
      let zonaImovel = imovel.zona === 'NAO_INFORMADO'? "" : (imovel.zona === 'CENTRO' ? ", " + this.getLabel(ZONAS, imovel.zona) : ", Zona " + this.getLabel(ZONAS, imovel.zona));
      return (imovel.bairro ? imovel.bairro.nome : "") + zonaImovel+ (imovel.cidade ? ", " + imovel.cidade.nome : "") + 
      (imovel.estado ? "-" + this.siglaEstado(imovel) : "") + (imovel.cep ? ", " + imovel.cep : "");
    },


    recuperarImovelParceiroHandler(imovel) {
      const payload = { id: imovel.id }
      
      this.showLoading();
      this.recuperarImovelParceiro(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    getLatLngImovel(lat, lgn) {
      return latLng(lat, lgn)
    },
    getLabelImovel(imovel){
      return (!imovel || !imovel.id ? "Novo Imóvel" : this.util.formatarLabelImovel(imovel, ESTADOS))
    },
    irParaSecao(){
      location.href = '#novo'
    },
    //BOTOES MOBILE
    retrairBotoes(){
      this.hoverGravar = false
      this.hoverRemover = false
      this.hoverGerarFicha = false
      this.hoverIndisponibilizar = false
      this.hoverDuplicar = false
      this.hoverDisponibilizarParaVenda = false
      this.hoverDisponibilizar = false
      this.hoverArquivar =  false
    },
    expandGravar(){
      this.retrairBotoes();
      this.hoverGravar = !this.hoverGravar
    },
    expandRemover(){
      this.retrairBotoes();
      this.hoverRemover = !this.hoverRemover
    },
    expandGerarFicha(){
      this.retrairBotoes();
      this.hoverGerarFicha = !this.hoverGerarFicha
    },
    expandIndisponibilizar(){
      this.retrairBotoes();
      this.hoverIndisponibilizar = !this.hoverIndisponibilizar
    },
    expandDuplicar(){
      this.retrairBotoes();
      this.hoverDuplicar = !this.hoverDuplicar
    },
    expandDisponibilizarParaVenda(){
      this.retrairBotoes();
      this.hoverDisponibilizarParaVenda = !this.hoverDisponibilizarParaVenda
    },
    expandDisponibilizar(){
      this.retrairBotoes();
      this.hoverDisponibilizar = !this.hoverDisponibilizar
    },
    expandArquivar(){
      this.retrairBotoes();
      this.hoverArquivar = !this.hoverArquivar
    },
    expandeDesarquivar(){
      this.retrairBotoes();
      this.hoverArquivar = !this.hoverArquivar
    }

  }
};